import * as React from "react";
import { useTranslation } from "react-i18next";
import useInputStateSummary from "hooks/useInputStateSummary";
import MenuItemDotBadge from "components/navigation/MenuItemDotBadge";
const InputsDotBadge = ({ text, hasExternalIssues = false, externalIssuesTitle = "" }) => {
  const { t } = useTranslation("inputs");
  const { hasProblematicInputs, isLoading } = useInputStateSummary();
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, text);
  }
  const showDot = hasProblematicInputs || hasExternalIssues;
  const title = hasProblematicInputs ? t("dot_badge.problematic_inputs") : externalIssuesTitle;
  return /* @__PURE__ */ React.createElement(MenuItemDotBadge, { text, title, showDot });
};
export default InputsDotBadge;
